module.exports = __webpack_public_path__ + "static/media/A-7ths.45f25c36.png";